import { t } from "../../i18n";
import { asRecord, formatKey } from "./ToolResultView.utils";

export function GenericValue({
  value,
  depth = 0,
}: {
  value: unknown;
  depth?: number;
}) {
  if (value === null || value === undefined)
    return <span className="text-stone-400">—</span>;
  if (typeof value === "string")
    return <span className="break-words whitespace-pre-wrap">{value}</span>;
  if (typeof value === "number" || typeof value === "boolean")
    return <span className="font-mono text-[11px]">{String(value)}</span>;
  if (depth > 1)
    return (
      <code className="text-[11px] break-all">{JSON.stringify(value)}</code>
    );
  if (Array.isArray(value)) {
    return value.length ? (
      <div className="space-y-1.5">
        {value.map((item, index) => (
          <div
            key={index}
            className="rounded-lg bg-stone-100/80 px-2.5 py-2 dark:bg-white/5"
          >
            <GenericValue value={item} depth={depth + 1} />
          </div>
        ))}
      </div>
    ) : (
      <span className="text-stone-400">{t("None")}</span>
    );
  }
  const record = asRecord(value);
  if (!record) return <code className="text-[11px]">{String(value)}</code>;
  return (
    <div className="divide-y divide-stone-200 overflow-hidden rounded-xl border border-stone-200 dark:divide-white/10 dark:border-white/10">
      {Object.entries(record).map(([key, item]) => (
        <div
          key={key}
          className="grid gap-1 px-3 py-2.5 sm:grid-cols-[9rem_1fr] sm:gap-3"
        >
          <div className="text-[11px] font-semibold text-stone-400">
            {formatKey(key)}
          </div>
          <div className="min-w-0 text-xs leading-5 text-stone-700 dark:text-stone-300">
            <GenericValue value={item} depth={depth + 1} />
          </div>
        </div>
      ))}
    </div>
  );
}
